"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MagazinePDF = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MagazinePDF = props => {
  const {
    magazineUrl
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-magazine-container"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    src: magazineUrl + '#view=FitH',
    width: "80%",
    height: "1000px"
  }));
};
exports.MagazinePDF = MagazinePDF;
MagazinePDF.propTypes = {
  magazineUrl: _propTypes.default.string
};